import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import Typed from 'react-typed';
import GetInTouch from "./GetInTouch";
import Resume from "./Resume";

const useStyles = makeStyles(() => ({
  root: {
    color: "#fff",
    padding: "5px 10px",
    margin: "10px 0",
  },
  content: {
    margin: "10px 0 !important",
    padding: "10px 5px",
  },
  typed: {
    color: '#15e0eb',
    fontSize: '28px'
  },
}));
export default function TagLine() {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Typography component="h2" className={classes.content}>
        Hello I'm
      </Typography>
      <Typed
        strings={['Jr Software Developer', 'React Developer', 'Programmer']}
        typeSpeed={80}
        backSpeed={80}
        startDelay={1000}
        backDelay={2000}
        loop
        className={classes.typed}
      />

      <Typography className={classes.content}>
        I'm a Javascript Fan with knowledge of React and Node JS. I'm alwyas try
        to exploring myself. Any new challange i wanna treat me. I wanna also a
        travel blogger.
      </Typography>

      <Resume /> <GetInTouch />
    </Box>
  );
}
